/* import __COLOCATED_TEMPLATE__ from './footer-message.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  classNames: ["footer-message"],
});
